import React from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink, NamedLink,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import {newsData} from '../../util/newsData';
import newsImage from './img/news1.png';


import css from './NewsListPage.module.css';
import NotFoundPage from '../NotFoundPage/NotFoundPage';

const NewsListPage = () => {
  const history = useHistory();

  useEffect(() => {
    history.replace('/');
  }, []);

  return <NotFoundPage />;

  const news = newsData.filter(n => n.page !== 'LandingPage')

  const newsListRenderer = news.map((n) => {
    return   <ExternalLink className={css.newsItem} href={n.link} >
        <img className={css.newsImg} src={n.imgSrc} alt={n.title}/>
        <div className={css.newsLink}>

          <h3 className={css.newsItemTitle}>{n.title}</h3>
        </div>

      </ExternalLink>

  })

  return (
    <StaticPage
      title="AllCourse in the News"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'NewsListPage',
        description: 'AllCourse in the News',
        name: 'AllCourse in the News',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.content}>
            <h1 className={css.newsPageTitle}>AllCourse in the News</h1>
            <div className={css.newsPageSubTitleHolder}>
              <h2 className={css.newsPageSubTitle}>About AllCourse</h2>
            </div>


            <div className={css.generalNewsListHolder}>
              <div className={css.generalNewsList}>

                <NamedLink className={css.generalNewsItem} name='NewsArticle1Page'>
                  <img className={css.generalNewsListImg} src={newsImage} alt="News Image"/>
                  <div className={css.generalNewsDataHolder}>
                    <h3 className={css.generalNewsTitle}>How AllCourse Can Solve Teacher Shortages and Credit Recovery Challenges in Your District</h3>
                    <span className={css.generalNewsAuthor}>T. Trent Gegax</span>
                    <span className={css.generalNewsDate}>May 9, 2023</span>
                  </div>
                </NamedLink>
              </div>
            </div>

            <div className={css.generalNewsInfo}>
              <p className={css.generalNewsInfoText}>District Administration </p>
            </div>

            <div className={css.newsPageSubTitleHolder}>
              <h2 className={css.newsPageSubTitle}>About our Founder</h2>
            </div>


            <div className={css.newsList}>
              {newsListRenderer}
            </div>
          </div>

        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default NewsListPage;
